import Content from '../../content.js';
import DataTables from '../../components/dataTables';
import Events from '../../../util/eventEmitter.js';

namespace('IO.Views.Nodes', function (exports) {
  'use strict';

  var Index = Content.extend({
    dom: {
      CURRENT_TABLE: '.tabs-content .active table',
      FIRST_TAB: '#tab0Tab',
      MASKED_PASSWORD: '.mask-password',
      TAB: '.tabs dd',
      FILTER_TRIGGER: '#nodes-filter-trigger',
      SEARCH_FILTERS: '#nodes-search-filters',
      NODE_GROUP_FILTER: '#node-filter',
      NODE_GROUP_ANCHOR: '.node-group div',
      NODE_GROUP_ACTIVE: '.node-group.active',
      NODE_GROUP_BUTTON_BACK: '#node-group-back',
      NEW_NODE_BUTTON:
        '.clearfix.node-actions .small.secondary.button.dropdown ul',
      DATATABLES_CONTAINER: '.datatables-container',
      GROUP_LISTING: '#node-groups-listing',
      SELECT2_FIELD: '.select2select',
      GROUP_SELECTOR: '.node-group-selector',
      COLUMN_SELECTOR: '#node_columns',
      GROUP_ACTIONS: '.node-group-actions',
    },

    /*
      PUBLIC FUNCTIONS
    */
    beforeRender: function () {
      this.groups = [];
      this.dataTables = [];
      this.selectedGroups = [];
      this.columns = [];
      this.columnsNames = [];
    },

    events: function () {
      var events = {};

      events['click ' + this.dom.FILTER_TRIGGER] = '_toggleFilters';
      events['click ' + this.dom.NODE_GROUP_BUTTON_BACK] = '_reset';
      return events;
    },

    onDestroy: function () {
      _.each(this.dataTables, function (dataTable) {
        dataTable.remove();
      });

      this._offCheckablePropertiesUpdates();
    },

    render: function () {
      var $select;

      this.$(this.dom.MASKED_PASSWORD).maskPassword();

      $select = this.$(this.dom.SELECT2_FIELD);

      $select.select2(
        window.select2Defaults({
          acceptNotFound: false,
          allowClear: true,
          placeholder: 'Any',
        }),
      );

      Events.on('nodes_rql_update', (columns, headers) => {
        this._lazyDrawDatatable(this._mountUrl(columns), headers);
      });

      this._lazyDrawDatatable();
    },

    /*
      PRIVATE FUNCTIONS
    */
    _reset: function () {
      $(this.dom.DATATABLES_CONTAINER).removeClass('active');
      $(this.dom.NODE_GROUP).removeClass('hidden-node-group active');
      $(this.dom.NODE_GROUP_BUTTON_BACK).addClass('hidden');
      $(this.dom.NODE_GROUP_FILTER_CONTAINER).removeClass('hidden');
      $(this.dom.NEW_NODE_BUTTON).removeClass('hidden');
    },

    _tableHeaders: function (headers) {
      var baseColumns = window.nodesColumnData.slice(),
        i;

      if (typeof headers === 'undefined') {
        return baseColumns;
      }
      for (i in headers) {
        baseColumns.push({
          sTitle: headers[i],
          bSortable: false,
        });
      }

      return baseColumns;
    },

    _mountUrl: function (columns) {
      var url = '/' + currentCustomer + '/nodes.json';

      url += '?custom_columns=' + columns.join(',');

      return url;
    },

    _handleCheckablePropertyListeners: function () {
      // on nodes index, every time a group is changed on the groups dropdown the listener has to change
      // and listen to different update events
      this._offCheckablePropertiesUpdates();
      this._listenCheckablePropertyUpdates();
    },

    _listenCheckablePropertyUpdates: function () {
      var owner, accessor;

      if (
        typeof this.selectedGroups === 'undefined' ||
        this.selectedGroups.length !== 1
      ) {
        return;
      }

      this.checkablePropertiesChannel = `/service_check_value_${this.selectedGroups[0]}`;
      this.subscriptionId = Messenger.on(
        this.checkablePropertiesChannel,
        (data) => {
          owner = data.hostname;

          data.changes.forEach((propData) => {
            accessor = `.${owner}.${propData.property_id}`;
            this._handleCheckablePropertyUpdate(
              propData,
              accessor,
              data.hostname,
            );
          });
        },
      );
    },

    _offCheckablePropertiesUpdates: function () {
      if (typeof this.subscriptionId === 'undefined') {
        return;
      }

      Messenger.off(this.checkablePropertiesChannel, this.subscriptionId);
      this.subscriptionId = undefined;
    },

    _getGroupByHostname() {
      return nodeGroupByHostname.filter(
        (entry) => entry[0] === 'hostname',
      )[0][1];
    },

    _handleCheckablePropertyUpdate: function (data, _target, hostname) {
      var target = $(_target),
        nodeGroupLink = `/${currentCustomer}/node_groups/${this._getGroupByHostname(hostname)}#section2`;

      if (
        !data.metadata.remote_error_at ||
        moment(data.metadata.remote_updated_at).valueOf() >
          moment(data.metadata.remote_error_at).valueOf()
      ) {
        target.removeClass('has-error');
        target.html(data.metadata.remote_value);
      } else {
        target.addClass('has-error');
        target.html(`<a href="${nodeGroupLink}">Error</a>`);
      }
    },

    _groupActions: function () {
      var show = this.selectedGroups.length === 1,
        actions = this.$(this.dom.GROUP_ACTIONS),
        groupID = show ? this.selectedGroups[0] : '',
        url = '/' + currentCustomer + '/node_groups/' + groupID;

      if (show) {
        actions
          .find('.export-nodes')
          .attr('href', url + '/export?columns=' + this.columns.join(','));
        actions.find('.edit-group').attr('href', url);
        actions.find('.button:not(.no-disable)').removeClass('disabled');
      } else {
        actions.find('.button:not(.no-disable)').addClass('disabled');
      }
    },

    _isDataTableInstantiated: function (table, group) {
      return table.length > 1 && this.groups.indexOf(group) !== -1;
    },

    _lazyDrawDatatable: function (url, headers) {
      var table,
        columns,
        baseStructure =
          '<table class="display dataTables ui selectable striped table nodes-table"></table>',
        source =
          typeof url === 'undefined'
            ? '/' + currentCustomer + '/nodes.json'
            : url,
        firstColumnIndex;

      columns = this._tableHeaders(headers);
      firstColumnIndex = this._isSensuEnabled() ? 1 : 0;

      if (typeof this.dataTable !== 'undefined') {
        this.dataTable.destroy();
        $('.nodes-table-container').html(baseStructure);
      }

      table = $('.nodes-table');

      this.dataTable = new DataTables({
        el: table,
        controller: 'nodes',
        columns: columns,
        fixed: false,
        filter: true,
        serverSide: true,
        ajax: {
          url: source,
          type: 'PUT', // Too much arguments due to the custom columns, we need to use PUT instead of GET
        },
        title: 'Click to edit',
        searchElem: $('#rql_search_value'),
        searchWhen: 'nodes_rql_submit',
        scrollX: true,
        stateSave: false,
        aoColumnDefs: [
          {
            aTargets: [firstColumnIndex + 1],
            aDataSort: [firstColumnIndex + 1, firstColumnIndex],
          },
          {
            aTargets: [firstColumnIndex],
            aDataSort: [firstColumnIndex, firstColumnIndex + 1],
          },
          {
            targets: 0,
            // Attaches sensu status span element to all status data.
            render: (data, type) => {
              if (
                nodesColumnData[0].sTitle == 'Status' &&
                (type === 'display' || type === 'filter')
              ) {
                return (
                  '<span class="ir sensu-status sensu-status-12px sensu-status-datatables sensu-status-' +
                  data +
                  '" title="' +
                  data +
                  '">' +
                  (data === 'online' ? 1 : 0) +
                  '</span>'
                );
              }
              return data;
            },
          },
        ],
        sorting: [[1, 'desc']],
        onFetch: (json) => {
          Events.emit('nodes_rql_fetch', json);
        },
      });

      this.dataTable.start();
    },

    _isSensuEnabled: function () {
      return $('.node-status-container > .node-status-single').length == 3;
    },

    _toggleFilters: function (e) {
      e.preventDefault();
      this.$(this.dom.FILTER_TRIGGER).toggleClass('-active');
      this.$(this.dom.SEARCH_FILTERS).toggle();
    },
  });

  exports.Index = Index;
});
